import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React, { useEffect } from 'react';
import '@/App.css';
import { LanguageProvider } from '@/context/LanguageContext';
import Header from '@/components/Header';
import Hero from '@/components/Hero';
import Mission from '@/components/Mission';
import Workflow from '@/components/Workflow';
import Services from '@/components/Services';
import FAQ from '@/components/FAQ';
import Contact from '@/components/Contact';
import Footer from '@/components/Footer';
import Lenis from 'lenis';
import AvisoLegal from './components/AvisoLegal';
import PoliticaPrivacidad from './components/PoliticaPrivacidad';
import PoliticaCookies from './components/PoliticaCookies';
import CookieBanner from './components/CookieBanner';
import BrandAudit from './components/BrandAudit';

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.6,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      touchMultiplier: 1.2,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    // Expose lenis globally so scroll-driven components can read it
    window.__lenis = lenis;

    return () => {
      delete window.__lenis;
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <Router>
        <div className="App" style={{ background: '#050505' }}>
          <Header />
          <CookieBanner />
          
          <Routes>
            {/* RUTA PRINCIPAL: Tu landing page de siempre */}
            <Route path="/" element={
              <main>
                <Hero />
                <Mission />
                <Workflow />
                <Services />
                <FAQ />
                <Contact />
              </main>
            } />

            {/* RUTAS LEGALES: Las nuevas páginas */}
            <Route path="/aviso-legal" element={<AvisoLegal />} />
            <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
            <Route path="/politica-cookies" element={<PoliticaCookies />} />
            <Route path="/auditoria-gratuita" element={<BrandAudit />} />
          </Routes>

          <Footer />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
